import jsPDF from "jspdf";
import { FreeResource } from "./freeResources";

export function createFreeResourcePdf(resource: FreeResource) {
    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const width = pdf.internal.pageSize.getWidth();
    const height = pdf.internal.pageSize.getHeight();
    const margin = 18;
    const safeContent = resource.content.replace(/[–—]/g, "-").replace(/[‘’]/g, "'").replace(/[“”]/g, '"');
    const lines = pdf.splitTextToSize(safeContent, width - margin * 2);
    let y = 30;

    pdf.setFillColor(7, 93, 204);
    pdf.rect(0, 0, width, 20, "F");
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(16);
    pdf.text("MockZo", margin, 13);
    pdf.setFontSize(9);
    pdf.text("BUILD  -  LEARN  -  GROW", width - margin, 13, { align: "right" });
    pdf.setTextColor(15, 23, 42);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(10.5);

    lines.forEach((line: string) => {
        if (y > height - 18) {
            pdf.addPage();
            y = 20;
        }
        pdf.text(line, margin, y);
        y += 5.2;
    });

    const pageCount = pdf.getNumberOfPages();
    for (let page = 1; page <= pageCount; page += 1) {
        pdf.setPage(page);
        pdf.setFontSize(8);
        pdf.setTextColor(100, 116, 139);
        pdf.text(`Free MockZo resource - Page ${page} of ${pageCount}`, width / 2, height - 8, { align: "center" });
    }
    return pdf.output("blob");
}
